import { List } from 'immutable';
import I18n from 'I18n';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { TIME_SERIES } from 'reporting-data/constants/configTypes';
import { COLUMN } from 'reporting-data/constants/chartTypes';
export const BASE_QUESTION_CONTEXT_UPDATES = {
  dateRange: {
    rangeType: 'THIS_QUARTER',
    entireCurrentUnit: true
  },
  configType: 'AGGREGATION'
};
export const QUESTIONS = {
  adNetworkPerformance: {
    questionId: 'adNetworkPerformance',
    subApp: SUB_APPS.ads,
    path: '/templates/marketing/ads',
    contextOverrides: {
      chartMetrics: List(['SUM|clicks']),
      tab: 'adNetworks'
    }
  },
  sourcesSessions: {
    questionId: 'sourcesSessions',
    subApp: SUB_APPS.sources,
    path: '/templates/marketing/sources',
    contextOverrides: {
      grouping: 'breakdown',
      chartMetrics: List(['SUM|visits'])
    }
  },
  pagesBounceRate: {
    questionId: 'pagesBounceRate',
    subApp: SUB_APPS.pages,
    path: '/templates/marketing/pages',
    contextOverrides: {
      grouping: 'breakdown',
      chartMetrics: List(['PERCENTILES|pageBounceRate'])
    }
  },
  deviceTypesBounceRate: {
    questionId: 'deviceTypesBounceRate',
    subApp: SUB_APPS.deviceTypes,
    path: '/templates/marketing/deviceTypes',
    contextOverrides: {
      grouping: 'breakdown',
      chartMetrics: List(['PERCENTILES|bounceRate'])
    }
  },
  commonDeviceTypes: {
    questionId: 'commonDeviceTypes',
    subApp: SUB_APPS.deviceTypes,
    path: '/templates/marketing/deviceTypes',
    contextOverrides: {
      grouping: 'breakdown',
      chartMetrics: List(['SUM|contacts'])
    }
  },
  countriesCustomerConversion: {
    questionId: 'countriesCustomerConversion',
    subApp: SUB_APPS.geolocation,
    path: '/templates/marketing/geolocation',
    contextOverrides: {
      grouping: 'breakdown',
      chartMetrics: List(['PERCENTILES|contactToCustomerRate'])
    }
  },
  browsersSessionLength: {
    questionId: 'browsersSessionLength',
    subApp: SUB_APPS.browsers,
    path: '/templates/marketing/browsers',
    contextOverrides: {
      grouping: 'breakdown',
      chartMetrics: List(['PERCENTILES|timePerSession'])
    }
  },
  formsSubmissions: {
    questionId: 'formsSubmissions',
    subApp: SUB_APPS.leadCapture,
    path: '/templates/marketing/leadCapture',
    contextOverrides: {
      grouping: 'breakdown',
      chartMetrics: List(['SUM|submissions'])
    }
  },
  contactsBySource: {
    questionId: 'contactsBySource',
    subApp: SUB_APPS.contactInsights,
    path: '/templates/marketing/contactInsights',
    contextOverrides: {
      grouping: 'hs_analytics_source'
    }
  },
  contactsLifecycleStages: {
    questionId: 'contactsLifecycleStages',
    subApp: SUB_APPS.contactInsights,
    path: '/templates/marketing/contactInsights',
    contextOverrides: {
      grouping: 'lifecyclestage'
    }
  },
  dealsTimeToClose: {
    questionId: 'dealsTimeToClose',
    subApp: SUB_APPS.dealVelocity,
    path: '/templates/sales/dealVelocity',
    contextOverrides: {
      grouping: 'hubspot_owner_id'
    }
  },
  forecastClosedWon: {
    questionId: 'forecastClosedWon',
    subApp: SUB_APPS.manualForecastTotal,
    path: '/templates/sales/manualForecastTotal',
    contextOverrides: {
      grouping: 'closedate',
      configType: TIME_SERIES,
      chartType: COLUMN
    }
  },
  salesRepQuotaAttainment: {
    questionId: 'salesRepQuotaAttainment',
    subApp: SUB_APPS.quotaAttainment,
    path: '/templates/sales/quotaAttainment',
    contextOverrides: {
      grouping: 'hubspot_owner_id'
    }
  },
  callCountAndSuccess: {
    questionId: 'callCountAndSuccess',
    subApp: SUB_APPS.callOutcomes,
    path: '/templates/sales/callOutcomes',
    contextOverrides: {
      grouping: 'hs_call_disposition'
    }
  },
  callCountAndSuccess_v2: {
    questionId: 'callCountAndSuccess_v2',
    subApp: SUB_APPS.calls,
    path: '/templates/sales/calls',
    contextOverrides: {
      grouping: 'hs_call_disposition',
      tab: 'callOutcomes'
    }
  },
  repConversations: {
    questionId: 'repConversations',
    subApp: SUB_APPS.conversations,
    path: '/templates/sales/conversations',
    contextOverrides: {
      grouping: 'hubspot_owner_id'
    }
  },
  highestActivityCount: {
    questionId: 'highestActivityCount',
    subApp: SUB_APPS.activities,
    path: '/templates/sales/activities',
    contextOverrides: {
      grouping: 'hubspot_owner_id'
    }
  },
  dealsCreated: {
    questionId: 'dealsCreated',
    subApp: SUB_APPS.dealsCreatedByRep,
    path: '/templates/sales/dealsCreatedByRep',
    contextOverrides: {
      grouping: 'hubspot_owner_id'
    }
  },
  fastestLeadResponseTime: {
    questionId: 'fastestLeadResponseTime',
    subApp: SUB_APPS.leadResponseTime,
    path: '/templates/sales/leadResponseTime',
    contextOverrides: {
      grouping: 'hubspot_owner_id'
    }
  },
  fastestLeadResponseTime_v2: {
    questionId: 'fastestLeadResponseTime_v2',
    subApp: SUB_APPS.leads,
    path: '/templates/sales/leads',
    contextOverrides: {
      grouping: 'hubspot_owner_id',
      tab: 'leadResponseTime'
    }
  },
  completedMeetings: {
    questionId: 'completedMeetings',
    subApp: SUB_APPS.meetingOutcomes,
    path: '/templates/sales/meetingOutcomes',
    contextOverrides: {
      grouping: 'hubspot_owner_id'
    }
  },
  completedMeetings_v2: {
    questionId: 'completedMeetings_v2',
    subApp: SUB_APPS.meetings,
    path: '/templates/sales/meetings',
    contextOverrides: {
      grouping: 'hubspot_owner_id',
      tab: 'meetingOutcomes'
    }
  },
  mostTasksCompleted: {
    questionId: 'mostTasksCompleted',
    subApp: SUB_APPS.taskOutcomes,
    path: '/templates/sales/taskOutcomes',
    contextOverrides: {
      grouping: 'hubspot_owner_id'
    }
  },
  mostTasksCompleted_v2: {
    questionId: 'mostTasksCompleted_v2',
    subApp: SUB_APPS.tasks,
    path: '/templates/sales/tasks',
    contextOverrides: {
      grouping: 'hubspot_owner_id',
      tab: 'taskOutcomes'
    }
  },
  avgTimeToCloseTicket: {
    questionId: 'avgTimeToCloseTicket',
    subApp: SUB_APPS.ticketTimeToClose,
    path: '/templates/service/ticketTimeToClose',
    contextOverrides: {
      grouping: 'hubspot_owner_id',
      tab: 'ticketTimeToCloseAllHours'
    }
  },
  timeToAssignChat: {
    questionId: 'timeToAssignChat',
    subApp: SUB_APPS.queueTime,
    path: '/templates/service/queueTime',
    contextOverrides: {
      grouping: 'hs_started_at'
    }
  },
  ticketsByCategory: {
    questionId: 'ticketsByCategory',
    subApp: SUB_APPS.supportVolume,
    path: '/templates/service/supportVolume',
    contextOverrides: {
      grouping: 'hs_ticket_category'
    }
  },
  customerSatisfaction: {
    questionId: 'customerSatisfaction',
    subApp: SUB_APPS.postSupportCSAT,
    path: '/templates/service/postSupportCSAT',
    contextOverrides: {}
  },
  ticketTimeInPipeline: {
    questionId: 'ticketTimeInPipeline',
    subApp: SUB_APPS.ticketTimeInPipeline,
    path: '/templates/service/ticketTimeInPipeline',
    contextOverrides: {
      grouping: 'createdate',
      configType: TIME_SERIES,
      chartType: COLUMN
    }
  },
  highestEmailReply: {
    questionId: 'highestEmailReply',
    subApp: SUB_APPS.emailRates,
    path: '/templates/sales/emailRates',
    contextOverrides: {
      grouping: 'hubspot_owner_id'
    }
  }
};

// used by questions on reports-list home pages
export const getQuestionCopy = questionId => I18n.text(`reports.collectionHomes.quickAnswers.questions.${questionId}`);
export const getQuestionContextOverrides = questionId => {
  const questionData = QUESTIONS[questionId];
  if (!questionData) {
    return null;
  }
  return questionData.contextOverrides;
};